import { z } from 'zod';

// Live in harmony with Trusted Types
z.config({ jitless: true });

export const loginSchema = z.object({
    email: z.string().min(1, 'Email is required').email('Invalid email address'),
    password: z.string().min(1, 'Password is required'),
});

export type LoginFormData = z.infer<typeof loginSchema>;

export const totpSchema = z.object({
    totp_code: z
        .string()
        .length(6, 'TOTP code must be 6 digits')
        .regex(/^\d+$/, 'TOTP code must contain only numbers'),
});

export type TotpFormData = z.infer<typeof totpSchema>;
